import type { AdvertisingQuery } from '@/api/types'

import { DEFAULT_MODEL } from './advertisingQuery'

/** The name the API gives the same file
 * (`advertising-<level>-<from>-to-<to>-<model>.csv`). */
export function csvFilename(query: AdvertisingQuery): string {
  const model = query.model ?? DEFAULT_MODEL
  return `advertising-${query.level}-${query.from}-to-${query.to}-${model}.csv`
}
